// pages/Dashboard.jsx
import BookDonationForm from "../../components/home/BookDonationForm";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <BookDonationForm />
    </HomeLayout>
  );
}
